import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type firstPageStateType = {
  isFirstPageHasBackButton: boolean;
};

const initialState: firstPageStateType = {
  isFirstPageHasBackButton: false,
};

export const firstPageSlice = createSlice({
  name: 'firstPage',
  initialState,
  reducers: {
    setIsFirstPageHasBackButton: (state, action: PayloadAction<boolean>) => {
      state.isFirstPageHasBackButton = action.payload;
    },
  },
});
